import { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    axios.get(`${API}/faqs`).then(res => setFaqs(res.data)).catch(() => {});
  }, []);

  if (faqs.length === 0) return null;

  return (
    <section className="py-20 bg-white" data-testid="faq-section">
      <div className="container-gymtots">
        <div className="text-center mb-12">
          <h2 
            className="text-3xl md:text-4xl font-bold text-[#2D3436] mb-3"
            style={{ fontFamily: 'Fredoka, cursive' }}
          >
            Common Questions
          </h2>
          <p className="text-[#636E72] text-base md:text-lg">
            Everything you need to know about Gymtots
          </p>
        </div>
        
        <div className="max-w-2xl mx-auto">
          {faqs.map((faq, index) => (
            <div 
              key={faq.id}
              className="border-b border-gray-100 last:border-0"
              data-testid={`faq-item-${faq.id}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full py-5 flex items-center justify-between text-left"
                data-testid={`faq-toggle-${faq.id}`}
              >
                <span className={`font-semibold pr-4 transition-colors ${openIndex === index ? 'text-[#ff3131]' : 'text-[#2D3436]'}`}
                  style={{ fontFamily: 'Fredoka, cursive' }}>
                  {faq.question}
                </span>
                <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                  openIndex === index ? 'bg-[#ff3131] text-white' : 'bg-gray-100 text-[#636E72]'
                }`}>
                  {openIndex === index ? (
                    <ChevronUp className="w-4 h-4" />
                  ) : (
                    <ChevronDown className="w-4 h-4" />
                  )}
                </div>
              </button>
              
              {openIndex === index && (
                <div className="pb-5 pr-12 animate-slide-up">
                  <p className="text-[#636E72] text-sm leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
